import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import RestaurantRoutes from "./components/RestaurantRoutes/RestaurantRoutes";
import ContactUs from "./components/MainPageWebsite/ContactUs/ContactUs";
import HomePage from "./components/MainPageWebsite/HomePage/HomePage";
import { indexStore } from "./store/indexStore";
import PrivacyPolicy from "./components/MainPageWebsite/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./components/MainPageWebsite/TermsOfService/TermsOfService";
import { useTheme } from "next-themes";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PricingPage from "./components/MainPageWebsite/Pricing/PricingPage";
import FeaturesPage from "./components/MainPageWebsite/Features/FeaturesPage";
import ServicesPage from "./components/MainPageWebsite/Services/ServicesPage";
function App() {
  const { style } = indexStore();
  const { theme } = useTheme();
  const [primary, setPrimary] = useState("#000");
  const [onPrimary, setOnPrimary] = useState("#fff");
  React.useEffect(() => {
    if (theme === "dark") {
      setPrimary(style?.background || "#000");
      setOnPrimary(style?.onBackground || "#fff");

      document.documentElement.style.setProperty(
        "--primary-color",
        style?.background || "#000"
      );
      document.documentElement.style.setProperty(
        "--onPrimary-color",
        style?.onBackground || "#fff"
      );
    } else {
      setPrimary(style?.primary || "#000");
      setOnPrimary(style?.onPrimary || "#fff");

      document.documentElement.style.setProperty(
        "--primary-color",
        style?.primary || "#000"
      );
      document.documentElement.style.setProperty(
        "--onPrimary-color",
        style?.onPrimary || "#fff"
      );
    }
  }, [theme, style]);

  return (
    <div
      style={
        {
          "--primary-color": primary,
          "--onPrimary-color": onPrimary,
        } as any
      }
    >
      <Routes>
        <Route path="/" Component={HomePage} />
        <Route path="/contact" Component={ContactUs} />
        <Route path="/services" Component={ServicesPage} />
        <Route path="/features" Component={FeaturesPage} />
        <Route path="/pricing" Component={PricingPage} />
        <Route path="/privacy-policy" Component={PrivacyPolicy} />
        <Route path="/terms-of-service" Component={TermsOfService} />
        <Route path="/*" Component={RestaurantRoutes} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
}

export default App;
